import httpBuildQuery from '../../../../procedures/http-build-query';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/template-basic-price-list`;

export default {
  index: async (query) => await axios.get(baseUri + httpBuildQuery(query)),
  softDelete: async ({ id }) => await axios.delete(`${ baseUri }/${ id }`),
};
